import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { BuscadorEvaluaciones } from "./features/Busqueda/BuscadorEvaluaciones";
import { TablaEvaluaciones } from "./features/Busqueda/TablaEvaluaciones";
import { useBusquedaEvaluaciones } from "./features/Busqueda/useBusquedaEvaluaciones";
import { EvaluacionesLayout } from "./shared/EvaluacionesLayout";
import styles from "./shared/Evaluaciones.module.css";

export function EvaluacionesPage() {
  const {
    tipo, texto, filas, cargando, error, buscado, origen,
    setTexto, cambiarTipo, buscar, nuevaEvaluacion,
  } = useBusquedaEvaluaciones();

  return (
    <EvaluacionesLayout
      titulo="Evaluaciones"
      subtitulo="Cada evaluación, un empleado y un servicio."
      accion={
        <Button type="primary" icon={<PlusOutlined />} onClick={nuevaEvaluacion}>
          Nueva evaluación
        </Button>
      }
    >
      <BuscadorEvaluaciones
        tipo={tipo}
        texto={texto}
        cargando={cargando}
        onTexto={setTexto}
        onTipo={cambiarTipo}
        onBuscar={buscar}
      />
      {buscado && (
        <section className={styles.section}>
          <div className={styles.sectionHeading}>
            <h2>Resultados de búsqueda</h2>
            <span>{filas.length} REGISTROS</span>
          </div>
          {error && (
            <p className={styles.error} role="alert">{error}</p>
          )}
          {!error && (
            <TablaEvaluaciones filas={filas} cargando={cargando} origen={origen} />
          )}
        </section>
      )}
      {!buscado && (
        <div className={styles.initial}>
          <SearchOutlined />
          <h2>Encuentra la evaluación que necesitas</h2>
          <p>Busca por empleado o servicio para consultar sus evaluaciones.</p>
        </div>
      )}
    </EvaluacionesLayout>
  );
}
